import { useState, useEffect } from 'react'

const Fullscreen = ({ className = 'btn btn-sm d-none d-md-block' }) => {
  const [isMaximized, setIsMaximized] = useState(false)

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fsElement =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement

      setIsMaximized(!!fsElement)
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', handleFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
    }
  }, [])

  const toggleMaximize = () => {
    const el = document.documentElement

    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      el.requestFullscreen
    ) {
      el.requestFullscreen().catch(err => console.error(err))
    } else if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    }
  }

  return (
    <button
      onClick={toggleMaximize}
      title={isMaximized ? 'Zmenšit okno' : 'Zvětšit okno'}
      className={className}
    >
      {isMaximized ? <i className="bi bi-fullscreen-exit"></i> : <i className="bi bi-fullscreen"></i>}
    </button>
  )
}

export default Fullscreen
